// import React, { useEffect, useState } from 'react';
// import {
//   Box, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   Chip, List, ListItem, ListItemText, ListItemIcon,
//   Grid, MenuItem, Select, InputLabel, FormControl,
//   Divider, Avatar, Typography
// } from '@mui/material';
// import { Delete, Edit, Visibility, Download, Person, Description, PersonAdd } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import api from '../../api/axiosInterceptor';

// export const MatterManagementComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [feList, setFeList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedMatter, setSelectedMatter] = useState(null);
//   const [viewDetailsDialog, setViewDetailsDialog] = useState(false);

//   const [formData, setFormData] = useState({
//     matter_type: '',
//     case_no: '',
//     fe: '',
//     prayer: '',
//     court_type: '',
//     opponents: '',
//     issues: '',
//     appearence_by: '',
//     filing_date: '',
//     prev_hearing_date: '',
//     next_hearing_date: '',
//     remarks: '',
//     status: '',
//     file_name: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [selectedFileVersion, setSelectedFileVersion] = useState('v1');
//   const [formErrors, setFormErrors] = useState({});
//   const [showMatterTypeOther, setShowMatterTypeOther] = useState(false);
//   const [showCourtTypeOther, setShowCourtTypeOther] = useState(false);
//   const [showAppearenceOther, setShowAppearenceOther] = useState(false);
//   const [showStatusOther, setShowStatusOther] = useState(false);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteMatter, setDeleteMatter] = useState(null);

//   const [viewDocsDialogOpen, setViewDocsDialogOpen] = useState(false);
//   const [matterDocs, setMatterDocs] = useState([]);

//   // Dropdown Options
//   const matterTypeOptions = [
//     { value: 'Misc', label: 'Misc' },
//     { value: 'FA', label: 'FA' },
//     { value: 'WP', label: 'WP' },
//     { value: 'Others', label: 'Others (specify)' }
//   ];

//   const courtTypeOptions = [
//     { value: 'Special Court', label: 'Special Court' },
//     { value: 'High Court', label: 'High Court' },
//     { value: 'Supreme Court', label: 'Supreme Court' },
//     { value: 'Others', label: 'Others (specify)' }
//   ];

//   const appearenceByOptions = [
//     { value: 'JRCL', label: 'JRCL' },
//     { value: 'SRCL', label: 'SRCL' },
//     { value: 'Others', label: 'Others (specify)' }
//   ];

//   const statusOptions = [
//     { value: 'Pending', label: 'Pending' },
//     { value: 'Hearing', label: 'Hearing' },
//     { value: 'Disposed', label: 'Disposed' },
//     { value: 'Others', label: 'Others (specify)' }
//   ];

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     {
//       id: 'fe_name',
//       field: 'fe_name',
//       headerName: 'FE',
//       width: 150,
//       renderCell: (params) => (
//         <Chip icon={<Person />} label={params.value} size="small" />
//       )
//     },
//     {
//       id: 'created_by_name',
//       field: 'created_by_name',
//       headerName: 'Created By',
//       width: 150,
//       renderCell: (params) => (
//         <Chip 
//           icon={<PersonAdd />} 
//           label={params.value} 
//           size="small" 
//           variant="outlined"
//         />
//       )
//     },
//     { id: 'matter_type', field: 'matter_type', headerName: 'Matter Type', width: 120 },
//     { id: 'case_no', field: 'case_no', headerName: 'Case No', width: 120 },
//     { id: 'court_type', field: 'court_type', headerName: 'Court', width: 120 },
//     {
//       id: 'status',
//       field: 'status',
//       headerName: 'Status',
//       width: 100,
//       renderCell: (params) => (
//         <Chip 
//           label={params.value} 
//           color={params.value === 'Pending' ? 'warning' : params.value === 'Hearing' ? 'info' : 'success'} 
//           size="small" 
//         />
//       )
//     },
//     {
//       id: 'docs_count',
//       field: 'docs_count',
//       headerName: 'Docs',
//       width: 80,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           size="small"
//           color="primary"
//           onClick={() => handleViewDocs(params.row)}
//           sx={{ cursor: 'pointer' }}
//         />
//       ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 180,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleViewDetails(params.row)}>
//             <Visibility />
//           </IconButton>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchFeList();
//     fetchMatters();
//   }, []);

//   const fetchFeList = () => {
//     api.get(`fe-mgmt/fe-base/`)
//       .then(response => {
//         setFeList(response.data);
//       })
//       .catch(error => {
//         console.error('Failed to fetch FE list:', error);
//       });
//   };

//   const fetchMatters = () => {
//     setLoading(true);
//     api.get(`/legal-app/matters/`)
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           fe_name: item.fe_details?.name_of_fe || item.fe?.name_of_fe || 'N/A',
//           matter_type: item.matter_type || 'N/A',
//           case_no: item.case_no || 'N/A',
//           court_type: item.court_type || 'N/A',
//           status: item.status || 'Pending',
//           created_by_name: item.created_by?.name || 'N/A',
//           docs_count: item.matter_docs?.length || 0,
//           fullData: item,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Failed to fetch matters:', error);
//         setSnackbarMessage('Failed to load matters data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleDropdownChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//     if (value !== 'Others') {
//       switch(field) {
//         case 'matter_type': setShowMatterTypeOther(false); break;
//         case 'court_type': setShowCourtTypeOther(false); break;
//         case 'appearence_by': setShowAppearenceOther(false); break;
//         case 'status': setShowStatusOther(false); break;
//       }
//     } else {
//       switch(field) {
//         case 'matter_type': setShowMatterTypeOther(true); break;
//         case 'court_type': setShowCourtTypeOther(true); break;
//         case 'appearence_by': setShowAppearenceOther(true); break;
//         case 'status': setShowStatusOther(true); break;
//       }
//     }
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const handleAddMatter = () => {
//     setIsEditMode(false);
//     setFormData({
//       matter_type: '', case_no: '', fe: '', prayer: '',
//       court_type: '', opponents: '', issues: '',
//       appearence_by: '', filing_date: '', prev_hearing_date: '',
//       next_hearing_date: '', remarks: '', status: 'Pending', 
//       file_name: ''
//     });
//     setSelectedFile(null);
//     setSelectedFileVersion('v1');
//     setFormErrors({});
//     setShowMatterTypeOther(false);
//     setShowCourtTypeOther(false);
//     setShowAppearenceOther(false);
//     setShowStatusOther(false);
//     setOpenFormDialog(true);
//   };

//   const handleViewDetails = (matter) => {
//     setSelectedMatter(matter);
//     setFormData({
//       matter_type: matter.fullData.matter_type || '',
//       case_no: matter.fullData.case_no || '',
//       fe: matter.fullData.fe || '',
//       prayer: matter.fullData.prayer || '',
//       court_type: matter.fullData.court_type || '',
//       opponents: matter.fullData.opponents || '',
//       issues: matter.fullData.issues || '',
//       appearence_by: matter.fullData.appearence_by || '',
//       filing_date: matter.fullData.filing_date || '',
//       prev_hearing_date: matter.fullData.prev_hearing_date || '',
//       next_hearing_date: matter.fullData.next_hearing_date || '',
//       remarks: matter.fullData.remarks || '',
//       status: matter.fullData.status || '',
//       file_name: matter.fullData.matter_docs?.[0]?.file_name || matter.fullData.file_name || '',
//     });
//     setShowMatterTypeOther(matter.fullData.matter_type && !['Misc', 'FA', 'WP'].includes(matter.fullData.matter_type));
//     setShowCourtTypeOther(matter.fullData.court_type && !['Special Court', 'High Court', 'Supreme Court'].includes(matter.fullData.court_type));
//     setShowAppearenceOther(matter.fullData.appearence_by && !['JRCL', 'SRCL'].includes(matter.fullData.appearence_by));
//     setShowStatusOther(matter.fullData.status && !['Pending', 'Hearing', 'Disposed'].includes(matter.fullData.status));
//     setMatterDocs(matter.fullData.matter_docs || []);
//     setViewDetailsDialog(true);
//   };

//   const handleEdit = (matter) => {
//     setIsEditMode(true);
//     setSelectedMatter(matter);
//     setFormData({
//       matter_type: matter.fullData.matter_type || '',
//       case_no: matter.fullData.case_no || '',
//       fe: matter.fullData.fe || '',
//       prayer: matter.fullData.prayer || '',
//       court_type: matter.fullData.court_type || '',
//       opponents: matter.fullData.opponents || '',
//       issues: matter.fullData.issues || '',
//       appearence_by: matter.fullData.appearence_by || '',
//       filing_date: matter.fullData.filing_date || '',
//       prev_hearing_date: matter.fullData.prev_hearing_date || '',
//       next_hearing_date: matter.fullData.next_hearing_date || '',
//       remarks: matter.fullData.remarks || '',
//       status: matter.fullData.status || '',
//       file_name: matter.fullData.matter_docs?.[0]?.file_name || matter.fullData.file_name || '',
//     });
//     setShowMatterTypeOther(matter.fullData.matter_type && !['Misc', 'FA', 'WP'].includes(matter.fullData.matter_type));
//     setShowCourtTypeOther(matter.fullData.court_type && !['Special Court', 'High Court', 'Supreme Court'].includes(matter.fullData.court_type));
//     setShowAppearenceOther(matter.fullData.appearence_by && !['JRCL', 'SRCL'].includes(matter.fullData.appearence_by));
//     setShowStatusOther(matter.fullData.status && !['Pending', 'Hearing', 'Disposed'].includes(matter.fullData.status));
//     setSelectedFile(null);
//     setSelectedFileVersion('v1');
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (matter) => {
//     setDeleteMatter(matter);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api.delete(`/legal-app/matters/${deleteMatter.id}/`)
//       .then(() => {
//         setSnackbarMessage('Matter deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchMatters();
//       })
//       .catch(error => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete matter.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteMatter(null);
//       });
//   };

//   const handleViewDocs = async (matter) => {
//     try {
//       const response = await api.get(`/legal-app/matters/${matter.id}/`);
//       setMatterDocs(response.data.matter_docs || []);
//       setFormData(prev => ({
//         ...prev,
//         file_name: response.data.matter_docs?.[0]?.file_name || response.data.file_name || ''
//       }));
//       setViewDocsDialogOpen(true);
//     } catch (error) {
//       console.error('Failed to fetch docs:', error);
//       setSnackbarMessage('Failed to load documents.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const getApiFieldValue = (field) => {
//     const value = formData[field];
//     if (value && !['Others'].includes(value)) {
//       return value;
//     }
//     return formData[`${field}_other`] || '';
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.case_no?.trim()) errors.case_no = 'Case number is required';
//     if (!formData.fe) errors.fe = 'FE is required';
//     if (!getApiFieldValue('status')) errors.status = 'Status is required';
//     if (!formData.file_name?.trim()) errors.file_name = 'File name is required';
//     if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
//       errors.file = 'File size must be less than 10MB';
//     }
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // ✅ Auto-populate file_name from selected file (works in both Add & Edit)
//       setFormData(prev => ({ ...prev, file_name: file.name }));
      
//       if (file.size > 10 * 1024 * 1024) {
//         setFormErrors(prev => ({ ...prev, file: 'File size must be less than 10MB' }));
//         setSelectedFile(null);
//       } else {
//         setFormErrors(prev => { 
//           const newErrors = { ...prev };
//           delete newErrors.file;
//           return newErrors;
//         });
//         setSelectedFile(file);
//       }
//     }
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;

//     setSubmitLoading(true);

//     const form = new FormData();
    
//     form.append('matter_type', getApiFieldValue('matter_type'));
//     form.append('court_type', getApiFieldValue('court_type'));
//     form.append('appearence_by', getApiFieldValue('appearence_by'));
//     form.append('status', getApiFieldValue('status'));
    
//     // Regular fields
//     form.append('case_no', formData.case_no || '');
//     form.append('fe', formData.fe || '');
//     form.append('prayer', formData.prayer || '');
//     form.append('opponents', formData.opponents || '');
//     form.append('issues', formData.issues || '');
//     form.append('filing_date', formData.filing_date || '');
//     form.append('prev_hearing_date', formData.prev_hearing_date || '');
//     form.append('next_hearing_date', formData.next_hearing_date || '');
//     form.append('remarks', formData.remarks || '');
//     form.append('file_name', formData.file_name || ''); // ✅ Sent to backend for both Add & Edit

//     if (selectedFile) {
//       form.append('matter_docs_file', selectedFile);
//       form.append('matter_docs_version', selectedFileVersion);
//     }

//     if (isEditMode) {
//       form.append('replace_matter_docs', 'false');
//       api.patch(`/legal-app/matters/${selectedMatter.id}/`, form, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       })
//         .then(() => {
//           setSnackbarMessage('Matter updated successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchMatters();
//         })
//         .catch(error => {
//           console.error('Update failed:', error);
//           setSnackbarMessage('Failed to update matter.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => {
//           setSubmitLoading(false);
//           setOpenFormDialog(false);
//         });
//     } else {
//       api.post(`/legal-app/matters/`, form, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       })
//         .then(() => {
//           setSnackbarMessage('Matter created successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchMatters();
//         })
//         .catch(error => {
//           console.error('Create failed:', error);
//           setSnackbarMessage('Failed to create matter.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => {
//           setSubmitLoading(false);
//           setOpenFormDialog(false);
//         });
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ backgroundColor: 'rgba(195, 234, 203, 0.1)', p: 2 }}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Matter Management
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddMatter}>
//           Add New Matter
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort="true"
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       {/* ✅ FORM DIALOG - File Name field is NOW NEXT TO Document Version */}
//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>{isEditMode ? 'Edit Matter' : 'Add New Matter'}</DialogTitle>
//         <DialogContent sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
          
//           {/* Matter Type */}
//           <Box sx={{ mb: 2 }}>
//             <FormControl fullWidth>
//               <InputLabel>Matter Type *</InputLabel>
//               <Select
//                 value={formData.matter_type}
//                 label="Matter Type *"
//                 onChange={(e) => handleDropdownChange('matter_type', e.target.value)}
//               >
//                 {matterTypeOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             {showMatterTypeOther && (
//               <TextField
//                 label="Specify Matter Type"
//                 fullWidth
//                 sx={{ mt: 1 }}
//                 value={formData.matter_type_other || ''}
//                 onChange={(e) => setFormData({ ...formData, matter_type_other: e.target.value })}
//               />
//             )}
//           </Box>

//           {/* Case No */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Case No *"
//               fullWidth
//               value={formData.case_no}
//               error={!!formErrors.case_no}
//               helperText={formErrors.case_no}
//               onChange={(e) => setFormData({ ...formData, case_no: e.target.value })}
//             />
//           </Box>

//           {/* FE */}
//           <Box sx={{ mb: 2 }}>
//             <FormControl fullWidth error={!!formErrors.fe}>
//               <InputLabel>FE *</InputLabel>
//               <Select
//                 value={formData.fe}
//                 label="FE *"
//                 onChange={(e) => setFormData({ ...formData, fe: e.target.value })}
//               >
//                 {feList.map((fe) => (
//                   <MenuItem key={fe.id} value={fe.id}>
//                     {fe.name_of_fe}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {formErrors.fe && <Typography variant="caption" color="error">{formErrors.fe}</Typography>}
//             </FormControl>
//           </Box>

//           {/* Prayer */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Prayer"
//               fullWidth
//               multiline
//               rows={2}
//               value={formData.prayer}
//               onChange={(e) => setFormData({ ...formData, prayer: e.target.value })}
//             />
//           </Box>

//           {/* Court Type */}
//           <Box sx={{ mb: 2 }}>
//             <FormControl fullWidth>
//               <InputLabel>Court Type</InputLabel>
//               <Select
//                 value={formData.court_type}
//                 label="Court Type"
//                 onChange={(e) => handleDropdownChange('court_type', e.target.value)}
//               >
//                 {courtTypeOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             {showCourtTypeOther && (
//               <TextField
//                 label="Specify Court Type"
//                 fullWidth
//                 sx={{ mt: 1 }}
//                 value={formData.court_type_other || ''}
//                 onChange={(e) => setFormData({ ...formData, court_type_other: e.target.value })}
//               />
//             )}
//           </Box>

//           {/* Appearance By */}
//           <Box sx={{ mb: 2 }}>
//             <FormControl fullWidth>
//               <InputLabel>Appearance By</InputLabel>
//               <Select
//                 value={formData.appearence_by}
//                 label="Appearance By"
//                 onChange={(e) => handleDropdownChange('appearence_by', e.target.value)}
//               >
//                 {appearenceByOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             {showAppearenceOther && (
//               <TextField
//                 label="Specify Appearance By"
//                 fullWidth
//                 sx={{ mt: 1 }}
//                 value={formData.appearence_by_other || ''}
//                 onChange={(e) => setFormData({ ...formData, appearence_by_other: e.target.value })}
//               />
//             )}
//           </Box>

//           {/* Status */}
//           <Box sx={{ mb: 2 }}>
//             <FormControl fullWidth error={!!formErrors.status}>
//               <InputLabel>Status *</InputLabel>
//               <Select
//                 value={formData.status}
//                 label="Status *"
//                 onChange={(e) => handleDropdownChange('status', e.target.value)}
//               >
//                 {statusOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {formErrors.status && <Typography variant="caption" color="error">{formErrors.status}</Typography>}
//             </FormControl>
//             {showStatusOther && (
//               <TextField
//                 label="Specify Status"
//                 fullWidth
//                 sx={{ mt: 1 }}
//                 value={formData.status_other || ''}
//                 onChange={(e) => setFormData({ ...formData, status_other: e.target.value })}
//               />
//             )}
//           </Box>

//           {/* Filing Date */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Filing Date"
//               type="date"
//               fullWidth
//               value={formData.filing_date}
//               onChange={(e) => setFormData({ ...formData, filing_date: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Box>

//           {/* Previous Hearing Date */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Previous Hearing Date"
//               type="date"
//               fullWidth
//               value={formData.prev_hearing_date}
//               onChange={(e) => setFormData({ ...formData, prev_hearing_date: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Box>

//           {/* Next Hearing Date */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Next Hearing Date"
//               type="date"
//               fullWidth
//               value={formData.next_hearing_date}
//               onChange={(e) => setFormData({ ...formData, next_hearing_date: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Box>

//           {/* Opponents */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Opponents"
//               fullWidth
//               value={formData.opponents}
//               onChange={(e) => setFormData({ ...formData, opponents: e.target.value })}
//             />
//           </Box>

//           {/* Issues */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Issues"
//               multiline
//               rows={3}
//               fullWidth
//               value={formData.issues}
//               onChange={(e) => setFormData({ ...formData, issues: e.target.value })}
//             />
//           </Box>

//           {/* Remarks */}
//           <Box sx={{ mb: 2 }}>
//             <TextField
//               label="Remarks"
//               multiline
//               rows={3}
//               fullWidth
//               value={formData.remarks}
//               onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
//             />
//           </Box>

//           {/* ✅ FILE UPLOAD SECTION - File Name is NOW RIGHT NEXT TO Document Version */}
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="subtitle2" gutterBottom sx={{ mb: 2 }}>File Upload (Optional)</Typography>
            
//             {/* File Upload Input */}
//             <input
//               accept="*"
//               style={{ display: 'block', marginBottom: '16px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error" sx={{ mb: 2 }}>
//                 {formErrors.file}
//               </Typography>
//             )}
//             {selectedFile && (
//               <Typography variant="body2" sx={{ mb: 2, color: 'success.main' }}>
//                 Selected: {selectedFile.name}
//               </Typography>
//             )}

//             {/* ✅ File Name & Document Version - TOGETHER IN A GRID */}
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={8}>
//                 <TextField
//                   label="File Name *"
//                   fullWidth
//                   required
//                   value={formData.file_name}
//                   error={!!formErrors.file_name}
//                   helperText={formErrors.file_name || 'Name for this matter file (stored with each version)'}
//                   onChange={(e) => setFormData({ ...formData, file_name: e.target.value })}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   label="Document Version"
//                   fullWidth
//                   size="small"
//                   value={selectedFileVersion}
//                   onChange={(e) => setSelectedFileVersion(e.target.value)}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitLoading}>
//             {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Create')}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* VIEW DETAILS DIALOG */}
//       <Dialog open={viewDetailsDialog} onClose={() => setViewDetailsDialog(false)} maxWidth="lg" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center">
//             <Description sx={{ mr: 2, color: 'primary.main' }} />
//             <Typography variant="h6">Matter Details</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ mt: 2 }}>
//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
//               Basic Information
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Matter Type" fullWidth value={formData.matter_type || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Case No" fullWidth value={formData.case_no || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="FE" fullWidth value={feList.find(f => f.id == formData.fe)?.name_of_fe || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Prayer" fullWidth value={formData.prayer || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Court Type" fullWidth value={formData.court_type || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Status" fullWidth value={formData.status || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Appearance By" fullWidth value={formData.appearence_by || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField 
//                   label="Created By" 
//                   fullWidth 
//                   value={selectedMatter?.fullData?.created_by?.name || 'N/A'} 
//                   InputProps={{ readOnly: true }}
//                 />
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
//               Dates & Details
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <TextField label="Filing Date" fullWidth value={formData.filing_date || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField label="Previous Hearing" fullWidth value={formData.prev_hearing_date || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField label="Next Hearing" fullWidth value={formData.next_hearing_date || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField label="Opponents" fullWidth value={formData.opponents || 'N/A'} InputProps={{ readOnly: true }} />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField 
//                   label="File Name" 
//                   fullWidth 
//                   value={formData.file_name || 'N/A'} 
//                   InputProps={{ readOnly: true }}
//                 />
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
//               Description
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <TextField 
//                   label="Issues" 
//                   multiline rows={3} 
//                   fullWidth 
//                   value={formData.issues || 'N/A'} 
//                   InputProps={{ readOnly: true }} 
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField 
//                   label="Remarks" 
//                   multiline rows={3} 
//                   fullWidth 
//                   value={formData.remarks || 'N/A'} 
//                   InputProps={{ readOnly: true }} 
//                 />
//               </Grid>
//             </Grid>

//             <Divider sx={{ my: 3 }} />

//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
//               Documents ({matterDocs.length}){formData.file_name && ` - "${formData.file_name}"`}
//             </Typography>
//             {matterDocs.length === 0 ? (
//               <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
//                 No documents uploaded
//               </Typography>
//             ) : (
//               <List>
//                 {matterDocs.map((doc, index) => (
//                   <ListItem key={index} divider>
//                     <ListItemIcon>
//                       <Avatar sx={{ bgcolor: 'primary.main' }}>
//                         <Download />
//                       </Avatar>
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={
//                         <>
//                           <Typography variant="body2" fontWeight="medium">
//                             {doc.file_name || 'Document'}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             Version: {doc.version || 'v1'}
//                           </Typography>
//                         </>
//                       }
//                       secondary={
//                         <a href={doc.docs} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
//                           {doc.docs?.split('/').pop() || 'View Document'}
//                         </a>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             )}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setViewDetailsDialog(false)} variant="outlined">Close</Button>
//           <Button 
//             onClick={() => { setViewDetailsDialog(false); handleEdit(selectedMatter); }} 
//             variant="contained" 
//             color="primary"
//             startIcon={<Edit />}
//           >
//             Edit Matter
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* DOCUMENTS DIALOG */}
//       <Dialog open={viewDocsDialogOpen} onClose={() => setViewDocsDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Documents{formData.file_name && ` - "${formData.file_name}"`}</DialogTitle>
//         <DialogContent>
//           {matterDocs.length === 0 ? (
//             <Typography>No documents found.</Typography>
//           ) : (
//             <List>
//               {matterDocs.map((doc, index) => (
//                 <ListItem key={index} divider>
//                   <ListItemIcon><Download /></ListItemIcon>
//                   <ListItemText
//                     primary={
//                       <>
//                         <Typography variant="body2" fontWeight="medium">
//                           {doc.file_name || 'Document'}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           Version: {doc.version || 'v1'}
//                         </Typography>
//                       </>
//                     }
//                     secondary={
//                       <a href={doc.docs} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
//                         {doc.docs?.split('/').pop() || 'View Document'}
//                       </a>
//                     }
//                   />
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setViewDocsDialogOpen(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete "{deleteMatter?.case_no || deleteMatter?.prayer}"?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
//           <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  Chip, List, ListItem, ListItemText, ListItemIcon,
  Grid, MenuItem, Select, InputLabel, FormControl,
  Divider, Avatar, Typography
} from '@mui/material';
import { Delete, Edit, Visibility, Download, Person, Description, PersonAdd } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import api from '../../api/axiosInterceptor';

export const MatterManagementComponent = () => {
  const [rows, setRows] = useState([]);
  const [feList, setFeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedMatter, setSelectedMatter] = useState(null);
  const [viewDetailsDialog, setViewDetailsDialog] = useState(false);

  const [formData, setFormData] = useState({
    matter_tittle: '',
    case_no: '',
    fe: '',
    prayer: '',
    court_type: '',
    opponents: '',
    issues: '',
    appearence_by: '',
    filing_date: '',
    prev_hearing_date: '',
    next_hearing_date: '',
    remarks: '',
    status: '',
    file_name: '',
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileVersion, setSelectedFileVersion] = useState('v1');
  const [formErrors, setFormErrors] = useState({});
  const [showMatterTypeOther, setShowMatterTypeOther] = useState(false);
  const [showCourtTypeOther, setShowCourtTypeOther] = useState(false);
  const [showAppearenceOther, setShowAppearenceOther] = useState(false);
  const [showStatusOther, setShowStatusOther] = useState(false);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteMatter, setDeleteMatter] = useState(null);

  const [viewDocsDialogOpen, setViewDocsDialogOpen] = useState(false);
  const [matterDocs, setMatterDocs] = useState([]);

  // Updated Dropdown Options based on model comments
  const matterTypeOptions = [
    { value: 'Writ Petition', label: 'Writ Petition' },
    { value: 'Misc', label: 'Misc' },
    { value: 'First Appeal', label: 'First Appeal' },
    { value: 'RP', label: 'RP' },
    { value: 'CCC', label: 'CCC' },
    { value: 'Others', label: 'Others (specify)' }
  ];

  const courtTypeOptions = [
    { value: 'High Court', label: 'High Court' },
    { value: 'Supreme Court', label: 'Supreme Court' },
    { value: 'District Court', label: 'District Court' },
    { value: 'Special Court', label: 'Special Court' },
    { value: 'Others', label: 'Others (specify)' }
  ];

  const appearenceByOptions = [
    { value: 'JRCL', label: 'JRCL' },
    { value: 'SRCL', label: 'SRCL' },
    { value: 'Others', label: 'Others (specify)' }
  ];

  const statusOptions = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Hearing', label: 'Hearing' },
    { value: 'Disposed', label: 'Disposed' },
    { value: 'Others', label: 'Others (specify)' }
  ];

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    {
      id: 'fe_name',
      field: 'fe_name',
      headerName: 'FE',
      width: 150,
      renderCell: (params) => (
        <Chip icon={<Person />} label={params.value} size="small" />
      )
    },
    {
      id: 'created_by_name',
      field: 'created_by_name',
      headerName: 'Created By',
      width: 150,
      renderCell: (params) => (
        <Chip 
          icon={<PersonAdd />} 
          label={params.value} 
          size="small" 
          variant="outlined"
        />
      )
    },
    { 
      id: 'matter_tittle', 
      field: 'matter_tittle', 
      headerName: 'Matter Title', 
      width: 150 
    },
    { id: 'case_no', field: 'case_no', headerName: 'Case No', width: 120 },
    { id: 'court_type', field: 'court_type', headerName: 'Court', width: 120 },
    {
      id: 'status',
      field: 'status',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => (
        <Chip 
          label={params.value} 
          color={params.value === 'Pending' ? 'warning' : params.value === 'Hearing' ? 'info' : 'success'} 
          size="small" 
        />
      )
    },
    {
      id: 'docs_count',
      field: 'docs_count',
      headerName: 'Docs',
      width: 80,
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          color="primary"
          onClick={() => handleViewDocs(params.row)}
          sx={{ cursor: 'pointer' }}
        />
      ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 180,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleViewDetails(params.row)}>
            <Visibility />
          </IconButton>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchFeList();
    fetchMatters();
  }, []);

  const fetchFeList = () => {
    api.get(`fe-mgmt/fe-base/`)
      .then(response => {
        setFeList(response.data);
      })
      .catch(error => {
        console.error('Failed to fetch FE list:', error);
      });
  };

  const fetchMatters = () => {
    setLoading(true);
    api.get(`/legal-app/matters/`)
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          fe_name: item.fe_details?.name_of_fe || item.fe?.name_of_fe || 'N/A',
          matter_tittle: item.matter_tittle || 'N/A', // Updated field name
          case_no: item.case_no || 'N/A',
          court_type: item.court_type || 'N/A',
          status: item.status || 'Pending',
          created_by_name: item.created_by?.name || 'N/A',
          docs_count: item.matter_docs?.length || 0,
          fullData: item,
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch matters:', error);
        setSnackbarMessage('Failed to load matters data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleDropdownChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (value !== 'Others') {
      switch(field) {
        case 'matter_tittle': setShowMatterTypeOther(false); break;
        case 'court_type': setShowCourtTypeOther(false); break;
        case 'appearence_by': setShowAppearenceOther(false); break;
        case 'status': setShowStatusOther(false); break;
      }
    } else {
      switch(field) {
        case 'matter_tittle': setShowMatterTypeOther(true); break;
        case 'court_type': setShowCourtTypeOther(true); break;
        case 'appearence_by': setShowAppearenceOther(true); break;
        case 'status': setShowStatusOther(true); break;
      }
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleAddMatter = () => {
    setIsEditMode(false);
    setFormData({
      matter_tittle: '', case_no: '', fe: '', prayer: '',
      court_type: '', opponents: '', issues: '',
      appearence_by: '', filing_date: '', prev_hearing_date: '',
      next_hearing_date: '', remarks: '', status: 'Pending', 
      file_name: ''
    });
    setSelectedFile(null);
    setSelectedFileVersion('v1');
    setFormErrors({});
    setShowMatterTypeOther(false);
    setShowCourtTypeOther(false);
    setShowAppearenceOther(false);
    setShowStatusOther(false);
    setOpenFormDialog(true);
  };

  const handleViewDetails = (matter) => {
    setSelectedMatter(matter);
    setFormData({
      matter_tittle: matter.fullData.matter_tittle || '', // Updated field name
      case_no: matter.fullData.case_no || '',
      fe: matter.fullData.fe || '',
      prayer: matter.fullData.prayer || '',
      court_type: matter.fullData.court_type || '',
      opponents: matter.fullData.opponents || '',
      issues: matter.fullData.issues || '',
      appearence_by: matter.fullData.appearence_by || '',
      filing_date: matter.fullData.filing_date || '',
      prev_hearing_date: matter.fullData.prev_hearing_date || '',
      next_hearing_date: matter.fullData.next_hearing_date || '',
      remarks: matter.fullData.remarks || '',
      status: matter.fullData.status || '',
      file_name: matter.fullData.matter_docs?.[0]?.file_name || matter.fullData.file_name || '',
    });
    setShowMatterTypeOther(matter.fullData.matter_tittle && !['Writ Petition', 'Misc', 'First Appeal', 'RP', 'CCC'].includes(matter.fullData.matter_tittle));
    setShowCourtTypeOther(matter.fullData.court_type && !['High Court', 'Supreme Court', 'District Court', 'Special Court'].includes(matter.fullData.court_type));
    setShowAppearenceOther(matter.fullData.appearence_by && !['JRCL', 'SRCL'].includes(matter.fullData.appearence_by));
    setShowStatusOther(matter.fullData.status && !['Pending', 'Hearing', 'Disposed'].includes(matter.fullData.status));
    setMatterDocs(matter.fullData.matter_docs || []);
    setViewDetailsDialog(true);
  };

  const handleEdit = (matter) => {
    setIsEditMode(true);
    setSelectedMatter(matter);
    setFormData({
      matter_tittle: matter.fullData.matter_tittle || '', // Updated field name
      case_no: matter.fullData.case_no || '',
      fe: matter.fullData.fe || '',
      prayer: matter.fullData.prayer || '',
      court_type: matter.fullData.court_type || '',
      opponents: matter.fullData.opponents || '',
      issues: matter.fullData.issues || '',
      appearence_by: matter.fullData.appearence_by || '',
      filing_date: matter.fullData.filing_date || '',
      prev_hearing_date: matter.fullData.prev_hearing_date || '',
      next_hearing_date: matter.fullData.next_hearing_date || '',
      remarks: matter.fullData.remarks || '',
      status: matter.fullData.status || '',
      file_name: matter.fullData.matter_docs?.[0]?.file_name || matter.fullData.file_name || '',
    });
    setShowMatterTypeOther(matter.fullData.matter_tittle && !['Writ Petition', 'Misc', 'First Appeal', 'RP', 'CCC'].includes(matter.fullData.matter_tittle));
    setShowCourtTypeOther(matter.fullData.court_type && !['High Court', 'Supreme Court', 'District Court', 'Special Court'].includes(matter.fullData.court_type));
    setShowAppearenceOther(matter.fullData.appearence_by && !['JRCL', 'SRCL'].includes(matter.fullData.appearence_by));
    setShowStatusOther(matter.fullData.status && !['Pending', 'Hearing', 'Disposed'].includes(matter.fullData.status));
    setSelectedFile(null);
    setSelectedFileVersion('v1');
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (matter) => {
    setDeleteMatter(matter);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/legal-app/matters/${deleteMatter.id}/`)
      .then(() => {
        setSnackbarMessage('Matter deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchMatters();
      })
      .catch(error => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete matter.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteMatter(null);
      });
  };

  const handleViewDocs = async (matter) => {
    try {
      const response = await api.get(`/legal-app/matters/${matter.id}/`);
      setMatterDocs(response.data.matter_docs || []);
      setFormData(prev => ({
        ...prev,
        file_name: response.data.matter_docs?.[0]?.file_name || response.data.file_name || ''
      }));
      setViewDocsDialogOpen(true);
    } catch (error) {
      console.error('Failed to fetch docs:', error);
      setSnackbarMessage('Failed to load documents.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const getApiFieldValue = (field) => {
    const value = formData[field];
    if (value && !['Others'].includes(value)) {
      return value;
    }
    return formData[`${field}_other`] || '';
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.case_no?.trim()) errors.case_no = 'Case number is required';
    if (!formData.fe) errors.fe = 'FE is required';
    if (!getApiFieldValue('status')) errors.status = 'Status is required';
    if (!formData.file_name?.trim()) errors.file_name = 'File name is required';
    if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
      errors.file = 'File size must be less than 10MB';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, file_name: file.name }));
      
      if (file.size > 10 * 1024 * 1024) {
        setFormErrors(prev => ({ ...prev, file: 'File size must be less than 10MB' }));
        setSelectedFile(null);
      } else {
        setFormErrors(prev => { 
          const newErrors = { ...prev };
          delete newErrors.file;
          return newErrors;
        });
        setSelectedFile(file);
      }
    }
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;

    setSubmitLoading(true);

    const form = new FormData();
    
    form.append('matter_tittle', getApiFieldValue('matter_tittle')); // Updated field name
    form.append('court_type', getApiFieldValue('court_type'));
    form.append('appearence_by', getApiFieldValue('appearence_by'));
    form.append('status', getApiFieldValue('status'));
    
    // Regular fields
    form.append('case_no', formData.case_no || '');
    form.append('fe', formData.fe || '');
    form.append('prayer', formData.prayer || '');
    form.append('opponents', formData.opponents || '');
    form.append('issues', formData.issues || '');
    form.append('filing_date', formData.filing_date || '');
    form.append('prev_hearing_date', formData.prev_hearing_date || '');
    form.append('next_hearing_date', formData.next_hearing_date || '');
    form.append('remarks', formData.remarks || '');
    form.append('file_name', formData.file_name || '');

    if (selectedFile) {
      form.append('matter_docs_file', selectedFile);
      form.append('matter_docs_version', selectedFileVersion);
    }

    if (isEditMode) {
      form.append('replace_matter_docs', 'false');
      api.patch(`/legal-app/matters/${selectedMatter.id}/`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          setSnackbarMessage('Matter updated successfully.');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          fetchMatters();
        })
        .catch(error => {
          console.error('Update failed:', error);
          setSnackbarMessage('Failed to update matter.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        })
        .finally(() => {
          setSubmitLoading(false);
          setOpenFormDialog(false);
        });
    } else {
      api.post(`/legal-app/matters/`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          setSnackbarMessage('Matter created successfully.');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          fetchMatters();
        })
        .catch(error => {
          console.error('Create failed:', error);
          setSnackbarMessage('Failed to create matter.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        })
        .finally(() => {
          setSubmitLoading(false);
          setOpenFormDialog(false);
        });
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ backgroundColor: 'rgba(195, 234, 203, 0.1)', p: 2 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Matter Management
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddMatter}>
          Add New Matter
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort="true"
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      {/* FORM DIALOG */}
      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit Matter' : 'Add New Matter'}</DialogTitle>
        <DialogContent sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
          
          {/* Matter Title - Updated from Matter Type */}
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Matter Title *</InputLabel>
              <Select
                value={formData.matter_tittle}
                label="Matter Title *"
                onChange={(e) => handleDropdownChange('matter_tittle', e.target.value)}
              >
                {matterTypeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {showMatterTypeOther && (
              <TextField
                label="Specify Matter Title"
                fullWidth
                sx={{ mt: 1 }}
                value={formData.matter_tittle_other || ''}
                onChange={(e) => setFormData({ ...formData, matter_tittle_other: e.target.value })}
              />
            )}
          </Box>

          {/* Case No */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Case No *"
              fullWidth
              value={formData.case_no}
              error={!!formErrors.case_no}
              helperText={formErrors.case_no}
              onChange={(e) => setFormData({ ...formData, case_no: e.target.value })}
            />
          </Box>

          {/* FE */}
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth error={!!formErrors.fe}>
              <InputLabel>FE *</InputLabel>
              <Select
                value={formData.fe}
                label="FE *"
                onChange={(e) => setFormData({ ...formData, fe: e.target.value })}
              >
                {feList.map((fe) => (
                  <MenuItem key={fe.id} value={fe.id}>
                    {fe.name_of_fe}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.fe && <Typography variant="caption" color="error">{formErrors.fe}</Typography>}
            </FormControl>
          </Box>

          {/* Prayer */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Prayer"
              fullWidth
              multiline
              rows={2}
              value={formData.prayer}
              onChange={(e) => setFormData({ ...formData, prayer: e.target.value })}
            />
          </Box>

          {/* Court Type */}
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Court Type</InputLabel>
              <Select
                value={formData.court_type}
                label="Court Type"
                onChange={(e) => handleDropdownChange('court_type', e.target.value)}
              >
                {courtTypeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {showCourtTypeOther && (
              <TextField
                label="Specify Court Type"
                fullWidth
                sx={{ mt: 1 }}
                value={formData.court_type_other || ''}
                onChange={(e) => setFormData({ ...formData, court_type_other: e.target.value })}
              />
            )}
          </Box>

          {/* Appearance By */}
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Appearance By</InputLabel>
              <Select
                value={formData.appearence_by}
                label="Appearance By"
                onChange={(e) => handleDropdownChange('appearence_by', e.target.value)}
              >
                {appearenceByOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {showAppearenceOther && (
              <TextField
                label="Specify Appearance By"
                fullWidth
                sx={{ mt: 1 }}
                value={formData.appearence_by_other || ''}
                onChange={(e) => setFormData({ ...formData, appearence_by_other: e.target.value })}
              />
            )}
          </Box>

          {/* Status */}
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth error={!!formErrors.status}>
              <InputLabel>Status *</InputLabel>
              <Select
                value={formData.status}
                label="Status *"
                onChange={(e) => handleDropdownChange('status', e.target.value)}
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.status && <Typography variant="caption" color="error">{formErrors.status}</Typography>}
            </FormControl>
            {showStatusOther && (
              <TextField
                label="Specify Status"
                fullWidth
                sx={{ mt: 1 }}
                value={formData.status_other || ''}
                onChange={(e) => setFormData({ ...formData, status_other: e.target.value })}
              />
            )}
          </Box>

          {/* Filing Date */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Filing Date"
              type="date"
              fullWidth
              value={formData.filing_date}
              onChange={(e) => setFormData({ ...formData, filing_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          {/* Previous Hearing Date */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Previous Hearing Date"
              type="date"
              fullWidth
              value={formData.prev_hearing_date}
              onChange={(e) => setFormData({ ...formData, prev_hearing_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          {/* Next Hearing Date */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Next Hearing Date"
              type="date"
              fullWidth
              value={formData.next_hearing_date}
              onChange={(e) => setFormData({ ...formData, next_hearing_date: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          {/* Opponents */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Opponents"
              fullWidth
              value={formData.opponents}
              onChange={(e) => setFormData({ ...formData, opponents: e.target.value })}
            />
          </Box>

          {/* Issues */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Issues"
              multiline
              rows={3}
              fullWidth
              value={formData.issues}
              onChange={(e) => setFormData({ ...formData, issues: e.target.value })}
            />
          </Box>

          {/* Remarks */}
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Remarks"
              multiline
              rows={3}
              fullWidth
              value={formData.remarks}
              onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
            />
          </Box>

          {/* FILE UPLOAD SECTION */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom sx={{ mb: 2 }}>File Upload (Optional)</Typography>
            
            <input
              accept="*"
              style={{ display: 'block', marginBottom: '16px' }}
              id="file-upload"
              type="file"
              onChange={handleFileChange}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                {formErrors.file}
              </Typography>
            )}
            {selectedFile && (
              <Typography variant="body2" sx={{ mb: 2, color: 'success.main' }}>
                Selected: {selectedFile.name}
              </Typography>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <TextField
                  label="File Name *"
                  fullWidth
                  required
                  value={formData.file_name}
                  error={!!formErrors.file_name}
                  helperText={formErrors.file_name || 'Name for this matter file (stored with each version)'}
                  onChange={(e) => setFormData({ ...formData, file_name: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Document Version"
                  fullWidth
                  size="small"
                  value={selectedFileVersion}
                  onChange={(e) => setSelectedFileVersion(e.target.value)}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitLoading}>
            {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Create')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* VIEW DETAILS DIALOG */}
      <Dialog open={viewDetailsDialog} onClose={() => setViewDetailsDialog(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Description sx={{ mr: 2, color: 'primary.main' }} />
            <Typography variant="h6">Matter Details</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
              Basic Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField label="Matter Title" fullWidth value={formData.matter_tittle || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="Case No" fullWidth value={formData.case_no || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="FE" fullWidth value={feList.find(f => f.id == formData.fe)?.name_of_fe || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="Prayer" fullWidth value={formData.prayer || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="Court Type" fullWidth value={formData.court_type || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="Status" fullWidth value={formData.status || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="Appearance By" fullWidth value={formData.appearence_by || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField 
                  label="Created By" 
                  fullWidth 
                  value={selectedMatter?.fullData?.created_by?.name || 'N/A'} 
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
              Dates & Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField label="Filing Date" fullWidth value={formData.filing_date || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField label="Previous Hearing" fullWidth value={formData.prev_hearing_date || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField label="Next Hearing" fullWidth value={formData.next_hearing_date || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField label="Opponents" fullWidth value={formData.opponents || 'N/A'} InputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField 
                  label="File Name" 
                  fullWidth 
                  value={formData.file_name || 'N/A'} 
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
              Description
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField 
                  label="Issues" 
                  multiline rows={3} 
                  fullWidth 
                  value={formData.issues || 'N/A'} 
                  InputProps={{ readOnly: true }} 
                />
              </Grid>
              <Grid item xs={12}>
                <TextField 
                  label="Remarks" 
                  multiline rows={3} 
                  fullWidth 
                  value={formData.remarks || 'N/A'} 
                  InputProps={{ readOnly: true }} 
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
              Documents ({matterDocs.length}){formData.file_name && ` - "${formData.file_name}"`}
            </Typography>
            {matterDocs.length === 0 ? (
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                No documents uploaded
              </Typography>
            ) : (
              <List>
                {matterDocs.map((doc, index) => (
                  <ListItem key={index} divider>
                    <ListItemIcon>
                      <Avatar sx={{ bgcolor: 'primary.main' }}>
                        <Download />
                      </Avatar>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <Typography variant="body2" fontWeight="medium">
                            {doc.file_name || 'Document'}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Version: {doc.version || 'v1'}
                          </Typography>
                        </>
                      }
                      secondary={
                        <a href={doc.docs} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
                          {doc.docs?.split('/').pop() || 'View Document'}
                        </a>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setViewDetailsDialog(false)} variant="outlined">Close</Button>
          <Button 
            onClick={() => { setViewDetailsDialog(false); handleEdit(selectedMatter); }} 
            variant="contained" 
            color="primary"
            startIcon={<Edit />}
          >
            Edit Matter
          </Button>
        </DialogActions>
      </Dialog>

      {/* DOCUMENTS DIALOG */}
      <Dialog open={viewDocsDialogOpen} onClose={() => setViewDocsDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Documents{formData.file_name && ` - "${formData.file_name}"`}</DialogTitle>
        <DialogContent>
          {matterDocs.length === 0 ? (
            <Typography>No documents found.</Typography>
          ) : (
            <List>
              {matterDocs.map((doc, index) => (
                <ListItem key={index} divider>
                  <ListItemIcon><Download /></ListItemIcon>
                  <ListItemText
                    primary={
                      <>
                        <Typography variant="body2" fontWeight="medium">
                          {doc.file_name || 'Document'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Version: {doc.version || 'v1'}
                        </Typography>
                      </>
                    }
                    secondary={
                      <a href={doc.docs} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
                        {doc.docs?.split('/').pop() || 'View Document'}
                      </a>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDocsDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete "{deleteMatter?.case_no || deleteMatter?.matter_tittle}"?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};